import ImageDetail from './ImageDetail';

export default ImageDetail;
